/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PayorSource
 */
export interface PayorSource {
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    payor_type: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    payor_source?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    list_on_claim_as?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    additional_information_priority?: PayorSourceAdditionalInformationPriorityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PayorSource
     */
    hold_from_billing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PayorSource
     */
    poc_required?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PayorSource
     */
    assignment_of_benefits?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PayorSource
     */
    active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PayorSource
     */
    patient_is_in_an_hmo?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PayorSource
     */
    generate_concurrent_workflow?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PayorSource
     */
    generate_oasis_workflow?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    payor_code?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    secondary_identification?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    priority_of_admission_or_visit?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    point_of_origin?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    claim_benefit_date?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PayorSource
     */
    covered_by_medicare?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PayorSource
     */
    authorization_on_file?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    medicare_number?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    medicare_a_effective?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    medicare_b_effective?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    authorization_date?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    policy_number?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    medicaid_number?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    claim_number?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    medicaid_effective?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    patient_relationship_to_insured?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    insured_last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    insured_first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    insured_gender?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    insured_party_dob?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    insured_address?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    insured_zip_code?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    insured_city?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    insured_state?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    insured_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    insured_email?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    employer_group_plan_number?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    employer_group_plan_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    employer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    employer_address?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    employer_zip_code?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    employer_city?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    employer_state?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    employer_primary_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    mbi?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    medicare_group_plan_number?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    medicare_policy_number?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    medicare_group_plan_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    medicare_medicaid_number?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    medicare_medicaid_effective?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    episode_timing?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    group_plan_number?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    group_plan_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    physician_medicaid_number?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    supply_billing?: string;
    /**
     * 
     * @type {string}
     * @memberof PayorSource
     */
    episode_length?: string;
}


/**
 * @export
 */
export const PayorSourceAdditionalInformationPriorityEnum = {
    Primary: 'PRIMARY',
    Secondary: 'SECONDARY',
    InformationalOnly: 'INFORMATIONAL ONLY'
} as const;
export type PayorSourceAdditionalInformationPriorityEnum = typeof PayorSourceAdditionalInformationPriorityEnum[keyof typeof PayorSourceAdditionalInformationPriorityEnum];


/**
 * Check if a given object implements the PayorSource interface.
 */
export function instanceOfPayorSource(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "payor_type" in value;

    return isInstance;
}

export function PayorSourceFromJSON(json: any): PayorSource {
    return PayorSourceFromJSONTyped(json, false);
}

export function PayorSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayorSource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'payor_type': json['payor_type'],
        'payor_source': !exists(json, 'payor_source') ? undefined : json['payor_source'],
        'list_on_claim_as': !exists(json, 'list_on_claim_as') ? undefined : json['list_on_claim_as'],
        'additional_information_priority': !exists(json, 'additional_information_priority') ? undefined : json['additional_information_priority'],
        'hold_from_billing': !exists(json, 'hold_from_billing') ? undefined : json['hold_from_billing'],
        'poc_required': !exists(json, 'poc_required') ? undefined : json['poc_required'],
        'assignment_of_benefits': !exists(json, 'assignment_of_benefits') ? undefined : json['assignment_of_benefits'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'patient_is_in_an_hmo': !exists(json, 'patient_is_in_an_hmo') ? undefined : json['patient_is_in_an_hmo'],
        'generate_concurrent_workflow': !exists(json, 'generate_concurrent_workflow') ? undefined : json['generate_concurrent_workflow'],
        'generate_oasis_workflow': !exists(json, 'generate_oasis_workflow') ? undefined : json['generate_oasis_workflow'],
        'payor_code': !exists(json, 'payor_code') ? undefined : json['payor_code'],
        'secondary_identification': !exists(json, 'secondary_identification') ? undefined : json['secondary_identification'],
        'priority_of_admission_or_visit': !exists(json, 'priority_of_admission_or_visit') ? undefined : json['priority_of_admission_or_visit'],
        'point_of_origin': !exists(json, 'point_of_origin') ? undefined : json['point_of_origin'],
        'claim_benefit_date': !exists(json, 'claim_benefit_date') ? undefined : json['claim_benefit_date'],
        'covered_by_medicare': !exists(json, 'covered_by_medicare') ? undefined : json['covered_by_medicare'],
        'authorization_on_file': !exists(json, 'authorization_on_file') ? undefined : json['authorization_on_file'],
        'medicare_number': !exists(json, 'medicare_number') ? undefined : json['medicare_number'],
        'medicare_a_effective': !exists(json, 'medicare_a_effective') ? undefined : json['medicare_a_effective'],
        'medicare_b_effective': !exists(json, 'medicare_b_effective') ? undefined : json['medicare_b_effective'],
        'authorization_date': !exists(json, 'authorization_date') ? undefined : json['authorization_date'],
        'policy_number': !exists(json, 'policy_number') ? undefined : json['policy_number'],
        'medicaid_number': !exists(json, 'medicaid_number') ? undefined : json['medicaid_number'],
        'claim_number': !exists(json, 'claim_number') ? undefined : json['claim_number'],
        'medicaid_effective': !exists(json, 'medicaid_effective') ? undefined : json['medicaid_effective'],
        'patient_relationship_to_insured': !exists(json, 'patient_relationship_to_insured') ? undefined : json['patient_relationship_to_insured'],
        'insured_last_name': !exists(json, 'insured_last_name') ? undefined : json['insured_last_name'],
        'insured_first_name': !exists(json, 'insured_first_name') ? undefined : json['insured_first_name'],
        'insured_gender': !exists(json, 'insured_gender') ? undefined : json['insured_gender'],
        'insured_party_dob': !exists(json, 'insured_party_dob') ? undefined : json['insured_party_dob'],
        'insured_address': !exists(json, 'insured_address') ? undefined : json['insured_address'],
        'insured_zip_code': !exists(json, 'insured_zip_code') ? undefined : json['insured_zip_code'],
        'insured_city': !exists(json, 'insured_city') ? undefined : json['insured_city'],
        'insured_state': !exists(json, 'insured_state') ? undefined : json['insured_state'],
        'insured_phone': !exists(json, 'insured_phone') ? undefined : json['insured_phone'],
        'insured_email': !exists(json, 'insured_email') ? undefined : json['insured_email'],
        'employer_group_plan_number': !exists(json, 'employer_group_plan_number') ? undefined : json['employer_group_plan_number'],
        'employer_group_plan_name': !exists(json, 'employer_group_plan_name') ? undefined : json['employer_group_plan_name'],
        'employer_name': !exists(json, 'employer_name') ? undefined : json['employer_name'],
        'employer_address': !exists(json, 'employer_address') ? undefined : json['employer_address'],
        'employer_zip_code': !exists(json, 'employer_zip_code') ? undefined : json['employer_zip_code'],
        'employer_city': !exists(json, 'employer_city') ? undefined : json['employer_city'],
        'employer_state': !exists(json, 'employer_state') ? undefined : json['employer_state'],
        'employer_primary_phone': !exists(json, 'employer_primary_phone') ? undefined : json['employer_primary_phone'],
        'mbi': !exists(json, 'mbi') ? undefined : json['mbi'],
        'medicare_group_plan_number': !exists(json, 'medicare_group_plan_number') ? undefined : json['medicare_group_plan_number'],
        'medicare_policy_number': !exists(json, 'medicare_policy_number') ? undefined : json['medicare_policy_number'],
        'medicare_group_plan_name': !exists(json, 'medicare_group_plan_name') ? undefined : json['medicare_group_plan_name'],
        'medicare_medicaid_number': !exists(json, 'medicare_medicaid_number') ? undefined : json['medicare_medicaid_number'],
        'medicare_medicaid_effective': !exists(json, 'medicare_medicaid_effective') ? undefined : json['medicare_medicaid_effective'],
        'episode_timing': !exists(json, 'episode_timing') ? undefined : json['episode_timing'],
        'group_plan_number': !exists(json, 'group_plan_number') ? undefined : json['group_plan_number'],
        'group_plan_name': !exists(json, 'group_plan_name') ? undefined : json['group_plan_name'],
        'physician_medicaid_number': !exists(json, 'physician_medicaid_number') ? undefined : json['physician_medicaid_number'],
        'supply_billing': !exists(json, 'supply_billing') ? undefined : json['supply_billing'],
        'episode_length': !exists(json, 'episode_length') ? undefined : json['episode_length'],
    };
}

export function PayorSourceToJSON(value?: PayorSource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'payor_type': value.payor_type,
        'payor_source': value.payor_source,
        'list_on_claim_as': value.list_on_claim_as,
        'additional_information_priority': value.additional_information_priority,
        'hold_from_billing': value.hold_from_billing,
        'poc_required': value.poc_required,
        'assignment_of_benefits': value.assignment_of_benefits,
        'active': value.active,
        'patient_is_in_an_hmo': value.patient_is_in_an_hmo,
        'generate_concurrent_workflow': value.generate_concurrent_workflow,
        'generate_oasis_workflow': value.generate_oasis_workflow,
        'payor_code': value.payor_code,
        'secondary_identification': value.secondary_identification,
        'priority_of_admission_or_visit': value.priority_of_admission_or_visit,
        'point_of_origin': value.point_of_origin,
        'claim_benefit_date': value.claim_benefit_date,
        'covered_by_medicare': value.covered_by_medicare,
        'authorization_on_file': value.authorization_on_file,
        'medicare_number': value.medicare_number,
        'medicare_a_effective': value.medicare_a_effective,
        'medicare_b_effective': value.medicare_b_effective,
        'authorization_date': value.authorization_date,
        'policy_number': value.policy_number,
        'medicaid_number': value.medicaid_number,
        'claim_number': value.claim_number,
        'medicaid_effective': value.medicaid_effective,
        'patient_relationship_to_insured': value.patient_relationship_to_insured,
        'insured_last_name': value.insured_last_name,
        'insured_first_name': value.insured_first_name,
        'insured_gender': value.insured_gender,
        'insured_party_dob': value.insured_party_dob,
        'insured_address': value.insured_address,
        'insured_zip_code': value.insured_zip_code,
        'insured_city': value.insured_city,
        'insured_state': value.insured_state,
        'insured_phone': value.insured_phone,
        'insured_email': value.insured_email,
        'employer_group_plan_number': value.employer_group_plan_number,
        'employer_group_plan_name': value.employer_group_plan_name,
        'employer_name': value.employer_name,
        'employer_address': value.employer_address,
        'employer_zip_code': value.employer_zip_code,
        'employer_city': value.employer_city,
        'employer_state': value.employer_state,
        'employer_primary_phone': value.employer_primary_phone,
        'mbi': value.mbi,
        'medicare_group_plan_number': value.medicare_group_plan_number,
        'medicare_policy_number': value.medicare_policy_number,
        'medicare_group_plan_name': value.medicare_group_plan_name,
        'medicare_medicaid_number': value.medicare_medicaid_number,
        'medicare_medicaid_effective': value.medicare_medicaid_effective,
        'episode_timing': value.episode_timing,
        'group_plan_number': value.group_plan_number,
        'group_plan_name': value.group_plan_name,
        'physician_medicaid_number': value.physician_medicaid_number,
        'supply_billing': value.supply_billing,
        'episode_length': value.episode_length,
    };
}

